import { render, staticRenderFns } from "./fundsourceFavorites.vue?vue&type=template&id=876ff5f8&"
import script from "./fundsourceFavorites.vue?vue&type=script&lang=js&"
export * from "./fundsourceFavorites.vue?vue&type=script&lang=js&"
import style0 from "./fundsourceFavorites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports